import { Root } from "./Toggle.style"

export const OpenToggleButton = ({ className, onClick }) => (
  <Root className={className} onClick={onClick}>
    <img src="/assets/images/menu_button.svg" alt="" />
  </Root>
)

export const CloseToggleButton = ({ className, onClick }) => (
  <Root className={className} onClick={onClick}>
    <img src="/assets/images/menu_button_close.svg" alt="" />
  </Root>
)
